import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { IplexDeviceSyncService } from "../../services/iplex-device-sync.service";
import { NetworkStatusService } from "../../../_services/network-status.service";
import { DeviceConnectDialogComponent } from "../../../inspection/dialogs/device-connect-dialog/device-connect-dialog.component";
import { IplexDeviceConnectModeService } from "../../services/iplex-device-connect-mode.service";
import { IplexDeviceContentsSelectDialogComponent } from "../dialog/iplex-device-contents-select-dialog/iplex-device-contents-select-dialog.component";
import { IplexDeviceStartConnectDialogComponent } from "../dialog/iplex-device-start-connect-dialog/iplex-device-start-connect-dialog.component";
import { IplexDeviceWifiSettingsDialogComponent } from "../dialog/iplex-device-wifi-settings-dialog/iplex-device-wifi-settings-dialog.component";
import { SelectLocalFolderPathDialogComponent } from "../dialog/select-local-folder-path-dialog/select-local-folder-path-dialog.component";
import { OfflineDataSyncService } from "../../../_services/offline-data-sync.service";
import { CommonSnackBarService } from "../../../_services/common-snack-bar.service";
import { SpinnerService } from "../../../_services/spinner.service";
import { SwitchToOfflineConfirmationDialogComponent } from "../dialog/switch-to-offline-confirmation-dialog/switch-to-offline-confirmation-dialog.component";
import { firstValueFrom } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { isDevelopment } from "../../../_shared/environment-helper";
import { RoutePage } from "../../../app-routes.enum";

@Component({
  selector: "app-iplex-device-connect-mode-overlay",
  templateUrl: "./iplex-device-connect-mode-overlay.component.html",
  styleUrls: ["./iplex-device-connect-mode-overlay.component.scss"],
  standalone: false
})
export class IplexDeviceConnectModeOverlayComponent {
  constructor(
    private router: Router,
    private networkStatusService: NetworkStatusService,
    private iplexDeviceConnectModeService: IplexDeviceConnectModeService,
    private iplexDeviceSyncService: IplexDeviceSyncService,
    private dialog: MatDialog,
    private offlineDataSyncService: OfflineDataSyncService,
    private snackBarService: CommonSnackBarService,
    private oscSpinnerService: SpinnerService,
    private translate: TranslateService
  ) {}

  get isOnline() {
    return this.networkStatusService.isOnline;
  }

  get isIplexDeviceConnectMode() {
    return this.iplexDeviceConnectModeService.isHttpsConnectMode;
  }

  get isWebDAVConnectMode() {
    return this.iplexDeviceConnectModeService.isWebDAVConnectMode;
  }

  get isDesktop() {
    return this.networkStatusService.isDesktop();
  }

  get isDev() {
    return isDevelopment();
  }

  get isBrianApp() {
    return this.networkStatusService.isBrianMode;
  }

  switchOffIplexDeviceConnectMode() {
    this.iplexDeviceSyncService.offHttpsConnectMode();
  }

  openWifiSettingDialog() {
    return this.dialog.open(IplexDeviceWifiSettingsDialogComponent, {
      width: "420px",
      minHeight: "496px",
      panelClass: "dialog-scroll"
    });
  }

  async openConnectDialog() {
    if (this.isOnline) {
      const dialogRef = this.dialog.open(SwitchToOfflineConfirmationDialogComponent, {
        width: "380px",
        minHeight: "310px",
        panelClass: "dialog-scroll"
      });

      const confirmed = await firstValueFrom(dialogRef.afterClosed());

      if (confirmed) {
        await this.changeToOffline();
      } else {
        return;
      }
    }

    this.dialog.open(IplexDeviceStartConnectDialogComponent, {
      width: "380px",
      minHeight: "310px",
      panelClass: "dialog-scroll"
    });
  }

  async changeToOffline() {
    this.oscSpinnerService.show(true);
    if (!(await this.offlineDataSyncService.syncOnlineData())) {
      return;
    }

    this.networkStatusService
      .switchOfflineMode()
      .then(async (isOnline) => {
        if (isOnline) {
          this.snackBarService.open(this.translate.instant("offlineHeader.switchToOfflineError"));
        } else {
          await this.offlineDataSyncService.syncAssetModuleData();
          this.router.navigate([RoutePage.InspectionList]);
        }
      })
      .catch((error) => {
        console.log(error);
        this.snackBarService.open(this.translate.instant("offlineHeader.switchToOfflineError"));
      });
  }

  // https://ossa-cloud.visualstudio.com/OSD%20Visol%20Solution/_sprints/backlog/OSD%20ViSOL%20for%20Brian%20Team/OSD%20Visol%20Solution/OSD%20ViSOL%20for%20Brian%20Iterations/FY24%20Third%20Quarter?workitem=29568
  // ToDo Added processing to obtain the registered Device stored in SQLite and use the stored token if it is valid.追加
  // If disabled, enter the PIN code for token acquisition from the dialog and acquire the token again.取得
  async OpenDeviceRegisterDialog() {
    // const connectDevice = await this.connectDeviceDbService.put(null).toPromise();
    // const isValidToken = connectDevice ? connectDevice.isValid : false;
    const isValidToken = false;
    if (isValidToken) {
      // Add validation process to check if ToDo saved token is valid
      // ToDo Add process to pass the saved token and start IPLEXOne.exe
    } else {
      const dialogRef = this.dialog.open(DeviceConnectDialogComponent, {
        maxWidth: "800px",
        maxHeight: "800px",
        data: {
          isIplexOne: true
        }
      });
      return dialogRef.afterClosed();
    }
  }

  openDirectFileTransferDialog() {
    const dialogRef = this.dialog.open(IplexDeviceContentsSelectDialogComponent, {
      width: "90%",
      height: "90%",
      maxWidth: "1080px",
      maxHeight: "960px",
      panelClass: "dialog-scroll"
    });
    return dialogRef.afterClosed();
  }

  openFolderSelectDialog() {
    this.dialog.open(SelectLocalFolderPathDialogComponent, {
      width: "640px",
      panelClass: "dialog-scroll"
    });
  }
}
